import React, {ReactNode} from 'react';
import './SectionToolbar.less';

export interface SectionToolbarProps {
  title: ReactNode;
  extra?: ReactNode;
  bordered?: boolean;
  className?: string;
}

const SectionToolbar: React.FC<SectionToolbarProps> = ({
                                                         title,
                                                         extra,
                                                         bordered = false,
                                                         className = '',
                                                       }) => (
  <div
    className={`gt-section-toolbar${bordered ? ' gt-section-toolbar--bordered' : ''}${
      className ? ` ${className}` : ''
    }`}
  >
    <h4 className="gt-section-toolbar-title">{title}</h4>
    {extra && <div className="gt-section-toolbar-extra">{extra}</div>}
  </div>
);

export default SectionToolbar;
